module.exports = __webpack_public_path__ + "img/banner_es.9687de6b.jpg";